// removed by extract-text-webpack-plugin
module.exports = {"white":"order-wrapper__white-2GKOg","noneSelected":"order-wrapper__noneSelected-3Io0s","message":"order-wrapper__message-1PhUe","messageFootnote":"order-wrapper__messageFootnote-jgOml","link":"order-wrapper__link-3Qbao","redirect":"order-wrapper__redirect-pPnfe","messageTitle":"order-wrapper__messageTitle-2V1-O","messageDescription":"order-wrapper__messageDescription-jszLM"};


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/order-wrapper/order-wrapper.css
// module id = 767
// module chunks = 0